import React, { useEffect, useState } from 'react';
import backgroundcfx from '../../resources/imgs/loginImage.png';
import backgroundrv from '../../resources/imgs/background-4seg-new.png';
import Loader from '../../components/Loader';
import logocfx from '../../resources/imgs/newlogo.png';
import logorv from '../../resources/imgs/logo.png';
import {
  Pushable,
  SideBarGrid,
  Logo,
  Pusher,
  ImageBackgroundCover,
  ImageBackgroundText,
  ImageBackground
} from './styles';
import { useLocation, useHistory, RouteComponentProps } from 'react-router-dom';
import { validateUser } from '../../services/oauth';
import * as Storage from '../../services/storage';
import { iRootDispatch } from '../../store';
import { UserState } from '../../types/UserState';
import { CurrentPageState, CurrentToggledMenuState } from '../../store/types/temp-types';
import { LoginFormProps } from '../oauth-login/types';
import { connect } from 'react-redux';
import { redirectToCapturePage, redirectToOAuthLogin } from '../../services/oauth';
import { trackLogin } from '../../services/analytics';

const mapDispatch = (dispatch: iRootDispatch) => ({
  updateUser: (user: UserState) => dispatch.user.updateUser(user),
  updateCurrentPage: (currentPage: CurrentPageState) =>
    dispatch.currentPage.updateCurrentPage(currentPage),
  updateCurrentToggledMenu: (state: CurrentToggledMenuState) =>
    dispatch.currentToggledMenu.updateCurrentToggledMenu(state)
});

export type LoginProps = ReturnType<typeof mapDispatch> &
  RouteComponentProps &
  LoginFormProps;

const AuthValidate = (props: LoginProps) => {
  const history = useHistory();
  const [isValidating, setIsValidanting] = useState(true);
  const { hash } = useLocation();
  const splits = hash.split('&');
  const token = splits[0].replace('#access_token=', '');
  const dateNow = new Date();

  const isRV = process.env.REACT_APP_IS_RV === 'true';
  const background = isRV ? backgroundrv : backgroundcfx;
  const logo = isRV ? logorv : logocfx;

  let result = false;
  let isExpired = '';
  let email = '';

  if (token.length) {
    Storage.set('id_token', token);
  }

  validateUser(token)
    .then(response => {
      const { loginRv, idToken, refreshToken, ...rest } = response;
      console.log(response);
      if (response.id && response.role && idToken && refreshToken) {
        result = true;
        Storage.set('name', response.name);
        response.email
          ? Storage.set('email', response.email)
          : Storage.set('email', 'sem email');
        Storage.set('uid', response.id);
        Storage.set('role', response.role);
        Storage.set('id_token', idToken);
        Storage.set('external_login', loginRv.toString());
        Storage.set('refresh_token', refreshToken);
        Storage.set('role_id', JSON.stringify(response.role_id));
        Storage.set('permissions', JSON.stringify(response.permissions, null, 2));
        Storage.set('login_at', JSON.stringify(dateNow.toISOString()));

        trackLogin({
          id: response.id,
          name: response.name,
          role: response.role,
          estateId: response.estateId,
          estate: response.estate
        });

        if (response.estate) {
          Storage.set('estate', JSON.stringify(response.estate));
        } else {
          Storage.remove('estate');
        }
        props.updateUser({ ...rest });
      } else {
        result = false;
        isExpired = response.message;
        email = response.email;
      }
    })
    .catch(e => {
      console.log(e.message);
      redirectToCapturePage();
    })
    .finally(() => {
      setIsValidanting(false);
      if (result) {
        const bondInsuranceHash = splits.find(c => c.includes('bondInsuranceId'));
        const analysisHash = splits.find(c => c.includes('bondInsuranceanalysisId'));

        const fireInsuranceHash = splits.find(c => c.includes('fireInsuranceId'));
        const fireInsuranceStage = splits.find(c => c.includes('stage'));

        if (bondInsuranceHash) {
          const bondInsuranceId = bondInsuranceHash.split('=')[1];
          const bondInsuranceAnalysisId = analysisHash?.split('=')[1];
          history.push('/admin/bond-insurances', {
            bondInsuranceId,
            bondInsuranceAnalysisId
          });
          return;
        }

        if (fireInsuranceHash && fireInsuranceStage) {
          const fireInsuranceId = fireInsuranceHash.split('=')[1];
          const stage = fireInsuranceStage.split('=')[1];
          if (stage === 'analysis') {
            history.push(
              `/admin/fire-insurance-budgets?fireInsuranceId=${fireInsuranceId}`
            );
            return;
          }

          if (stage === 'policy') {
            history.push(
              `/admin/fire-insurance-policies?fireInsuranceId=${fireInsuranceId}`
            );
            return;
          }
        }

        history.push('/admin/dashboard');
      } else if (isExpired === 'jwt expired') {
        redirectToOAuthLogin(email);
      } else {
        redirectToCapturePage();
      }
    });

  if (isValidating) {
    return (
      <>
        <Loader />
      </>
    );
  }

  return (
    <>
      <Pushable>
        <SideBarGrid>
          <Logo src={logo} />
        </SideBarGrid>

        <Pusher>
          <ImageBackground src={background} />
        </Pusher>
      </Pushable>
    </>
  );
};

export default connect(null, mapDispatch)(AuthValidate);
